import React from 'react';
import { sanitiseText } from '../listingFieldUtils';

import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import PublicRoundedIcon from '@mui/icons-material/PublicRounded';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import css from '../ListingPage.module.css';
import { useGetListingByIdQuery } from '../../../api/store/apiSlice';
import { Text } from '@chakra-ui/react';

const SectionSocialMediaLinksMaybe = ({ publicData, authorPublicData, fallbackDisplayName }) => {
  if (!publicData && !authorPublicData) return null;

  const { data = {} } = useGetListingByIdQuery(publicData?.parentListingId, {
    skip: !publicData?.parentListingId,
  });

  let websiteUrl = publicData?.websiteUrl || '';
  let instagram = publicData?.instagram || '';
  let facebook = publicData?.facebook || '';
  let whatsappNumber = sanitiseText('whatsappNumber', publicData?.whatsappNumber) || '';

  if (publicData?.parentListingId || !!authorPublicData) {
    const parentPublicData = data?.data?.data?.attributes?.publicData;

    websiteUrl = websiteUrl || parentPublicData?.websiteUrl || authorPublicData?.websiteUrl || '';
    instagram = instagram || parentPublicData?.instagram || authorPublicData?.instagram || '';
    facebook = facebook || parentPublicData?.facebook || authorPublicData?.facebook || '';
    whatsappNumber =
      whatsappNumber ||
      sanitiseText(
        'whatsappNumber',
        parentPublicData?.whatsappNumber || authorPublicData?.whatsappNumber
      ) ||
      '';
  }

  return (
    <section id={'social-media-links'} className={css.socialMediaLinksSection}>
      {publicData?.location?.address && (
        <a
          href={`https://google.com/maps/?q=${publicData?.location?.building || ''} ${
            publicData?.location?.address
          }`}
          target="_blank"
          rel="noopener noreferrer"
          className={css.socialMediaLink}
        >
          <LocationOnRoundedIcon className={css.socialMediaIcon} aria-label={'Location icon'} />
          <Text p={0} m={0} lineClamp="2" className={css.socialMediaText}>
            {`${(publicData?.location?.building && publicData?.location?.building + ',') || ''} ${
              publicData?.location?.address
            } `}
          </Text>
        </a>
      )}
      {websiteUrl && (
        <div className={css.socialMediaLink}>
          <PublicRoundedIcon className={css.socialMediaIcon} aria-label={'Website icon'} />
          <Text p={0} m={0} lineClamp="1" className={css.socialMediaText}>
            {sanitiseText('websiteUrl', websiteUrl)}
          </Text>
        </div>
      )}
      {instagram && (
        <div className={css.socialMediaLink}>
          <InstagramIcon className={css.socialMediaIcon} aria-label={'Instagram icon'} />
          <Text p={0} m={0} lineClamp="1" className={css.socialMediaText}>
            {sanitiseText('instagram', instagram)}
          </Text>
        </div>
      )}
      {facebook && (
        <div className={css.socialMediaLink}>
          <FacebookIcon className={css.socialMediaIcon} aria-label={'Facebook icon'} />
          <Text p={0} m={0} lineClamp="1" className={css.socialMediaText}>
            {sanitiseText('facebook', facebook, fallbackDisplayName)}
          </Text>
        </div>
      )}
      {whatsappNumber && (
        <div className={css.socialMediaLink}>
          <WhatsAppIcon className={css.socialMediaIcon} aria-label={'Whatsapp icon'} />
          <Text p={0} m={0} lineClamp="2" className={css.socialMediaText}>
            <a
              className={css.socialMediaText}
              href={`tel:${whatsappNumber.replace(/\\s/g, '')}`}
              target="_blank"
            >
              {whatsappNumber}
            </a>
          </Text>
        </div>
      )}
    </section>
  );
};

export default SectionSocialMediaLinksMaybe;
